import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthContextProvider } from "./context/AuthContext";
import { CodesContextProvider } from "./context/CodesContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <CodesContextProvider>
          <App />
      </CodesContextProvider>
    </AuthContextProvider>
  </React.StrictMode>
);
